import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgRemoveLinkSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.42639 4.17116C5.22765 4.29035 5.04252 4.43259 4.87512 4.5956L4.87508 4.59556L4.86683 4.60377L0.852195 8.60541L0.8273 8.63022L0.80421 8.65672C0.239163 9.30521 -0.0476793 10.1497 0.00648405 11.0082C0.0614492 11.8793 0.393056 12.5456 1.053 13.2034C1.71395 13.8622 2.38463 14.1915 3.25635 14.2459C4.11608 14.2997 4.96277 14.0145 5.61429 13.4517C6.03223 13.0906 6.07835 12.4591 5.71731 12.0412C5.35627 11.6233 4.72479 11.5771 4.30685 11.9382C4.05152 12.1588 3.71905 12.271 3.38109 12.2498C3.05514 12.2295 2.82704 12.1478 2.46492 11.7869C2.10178 11.4249 2.02267 11.2016 2.00251 10.8822C1.98219 10.5601 2.08587 10.2424 2.29259 9.99353L6.27393 6.02508C6.39849 5.90495 6.55247 5.8186 6.72098 5.77486C6.8134 5.75087 6.90838 5.74017 7.00308 5.74274L5.42639 4.17116ZM8.53531 7.27001C8.53941 7.37479 8.53208 7.48013 8.5132 7.58416C8.41458 8.12757 8.77515 8.64804 9.31856 8.74666C9.53539 8.78602 9.74858 8.75225 9.93276 8.66294L8.53531 7.27001ZM10.3669 9.09563L9.31839 10.1408C9.17207 10.2817 8.994 10.3863 8.79883 10.4456C8.60309 10.5051 8.39559 10.5173 8.19341 10.481C8.09441 10.4621 7.94073 10.4042 7.76809 10.3069C7.5936 10.2086 7.47419 10.1123 7.4357 10.074C7.29355 9.93226 7.13196 9.68543 7.06925 9.48497L7.06622 9.47528L7.06299 9.46565C7.00053 9.27935 6.97876 9.08197 6.9991 8.88666C7.05628 8.33735 6.65733 7.84568 6.10802 7.78849C5.5587 7.73131 5.06703 8.13026 5.00985 8.67957C4.96025 9.15599 5.01267 9.63743 5.1636 10.092C5.33884 10.645 5.69156 11.1593 6.02378 11.4905C6.22348 11.6895 6.50125 11.8887 6.78632 12.0493C7.07193 12.2103 7.43917 12.3746 7.82794 12.4473L7.83301 12.4483C8.34826 12.5419 8.87881 12.5117 9.38056 12.3591C9.882 12.2067 10.3399 11.9367 10.7158 11.5717L10.7159 11.5717L10.7251 11.5625L11.7834 10.5076L10.3669 9.09563ZM12.4916 9.80156L11.0751 8.38964L13.6382 5.83464C13.7563 5.70833 13.8487 5.56082 13.9104 5.40021C13.9735 5.23589 14.0035 5.06114 13.9987 4.88545C13.9939 4.70955 13.9544 4.53626 13.8824 4.37573C13.8181 4.23224 13.7633 4.14569 13.5652 3.94817L13.5652 3.9482C13.5649 3.9479 13.562 3.9451 13.5561 3.93987C13.5494 3.93398 13.54 3.92607 13.5277 3.91631C13.5029 3.89656 13.4701 3.87226 13.4296 3.84489C13.348 3.78972 13.2469 3.72983 13.1362 3.6751C12.894 3.55528 12.6987 3.50563 12.5969 3.50348C12.2411 3.49598 11.8971 3.62766 11.6383 3.86917L11.1065 4.39937C10.7154 4.7893 10.0823 4.78835 9.69233 4.39724C9.30239 4.00612 9.30335 3.37296 9.69446 2.98302L10.2364 2.44276L10.2452 2.43392L10.2543 2.4253C10.8966 1.81628 11.7538 1.48526 12.639 1.50392C13.1594 1.51489 13.6597 1.70273 14.023 1.88244C14.3876 2.06276 14.7456 2.30095 14.9771 2.53166C15.3031 2.85659 15.52 3.13938 15.7075 3.55767C15.8873 3.95893 15.986 4.39172 15.9979 4.83091C16.0099 5.27029 15.9349 5.70739 15.7773 6.11766C15.6195 6.5281 15.3823 6.90307 15.0794 7.22143L15.0703 7.23105L15.0608 7.24042L12.4916 9.80156ZM10.5012 7.8176L6.45769 3.7872C6.88186 3.7132 7.31789 3.73084 7.7361 3.83991C8.33968 3.97486 8.89097 4.20519 9.40589 4.72413L9.4084 4.72666C9.76569 5.08933 10.1503 5.63605 10.3405 6.18141C10.5256 6.70648 10.5804 7.26785 10.5012 7.8176Z"
      fill={props.color}
    />
    <path
      d="M0.999512 1.00037L14.9995 15.0004"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgRemoveLinkSmall.displayName = 'SvgRemoveLinkSmall';
const RemoveLinkSmall = withForgeIconProps(SvgRemoveLinkSmall, {
  name: 'RemoveLink',
  usage: 'Use to remove a link.',
  related: 'text editor, hyperlink, edit',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default RemoveLinkSmall;
